import React from "react";
import { SidebarItemComponent } from "./sidebar-item.component";

const SidebarItemContainer = (props: any) => {
  return <SidebarItemComponent {...props} />;
};

export default SidebarItemContainer;
